import React, { Component } from 'react'
import '../styles/CropsPlanted.css'
import DropdownWidget from '../widgets/DropdownWidget'
import InputTextFilterWidget from '../widgets/InputTextFilterWidget'
import deleteIcon from '../images/trash_green.png'
import addIcon from '../images/plus_green.png'
import deleteIconGray from '../images/trash_gray.png'
import addIconGray from '../images/plus_gray.png'
import APIFarmerRequest from '../api/APIFarmerRequest'
import AlertMessage from '../widgets/AlertMessage'

class CropsPlanted extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			itemObj: {},
			keyTracer: 0,
			permanentListItems: [],
			otherItemObj: {},
			otherKeyTracer: 0,
			otherListItems: [],
			pcCount: 0,
			ocCount: 0,
			crops: {},
			cropsPlanted: {},
			addCrop:{},
			deleteCrop: {},
		}
		this.eventHandler = this.eventHandler.bind(this)
		this.getFarmerInfo = this.getFarmerInfo.bind(this)
		this.setAllFieldsDisabled = this.setAllFieldsDisabled.bind(this)
		this.setItems = this.setItems.bind(this)
		pclRanks = []
		selectedPclRanks = {}
		oclRanks = []
		selectedOclRanks = {}
	}

	getFarmerInfo() {
		const farmer = APIFarmerRequest.getFarmerDetailsById(this.state.accessToken, parseInt(this.props.farmerID))
		farmer.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			if(this.props.view === "update") {
				const instrument = APIFarmerRequest.getAllCrops(this.state.accessToken)
				instrument.then((rc) => {
					if(rc.status === "FAILED") {
						return
					}
					const c = []
					for(const v of rc.results.rows) {
						c.push({id: v.crop_id, name: v.name})
					}
					this.setItems(response.results.existingCropAndMarket, c)
				})
				return
			}
			this.setItems(response.results.existingCropAndMarket)
		})
	}

	setItems(existingCropAndMarket, crops) {
		const pc = []
		const oc = []
		for(const v of existingCropAndMarket) {
			if(v.no_of_productive_tree != null) {
				const k = "pcl-" + this.state.keyTracer
				this.state.keyTracer++
				this.state.pcCount++
				const pcl = <PermanentCropListItem data={v} crops={crops} view={this.props.view} handler={this.eventHandler} key={k} id={k} />
				pc.push(pcl)
				this.state.itemObj[k] = pcl
				pclRanks.push({id: this.state.pcCount, name: this.state.pcCount})
			}
			else {
				const ok = "ocl-" + this.state.otherKeyTracer
				this.state.otherKeyTracer++
				this.state.ocCount++
				const ocl = <OtherCropListItem data={v} crops={crops} view={this.props.view} handler={this.eventHandler} key={ok} id={ok} />
				oc.push(ocl)
				this.state.otherItemObj[ok] = ocl
				oclRanks.push({id: this.state.ocCount, name: this.state.ocCount})
			}
		}
		const k = "pcl-" + this.state.keyTracer
		this.state.keyTracer++
		const pcl = <PermanentCropListItem crops={crops} view={this.props.view} handler={this.eventHandler} key={k} id={k} />
		pc.push(pcl)
		this.state.itemObj[k] = pcl
		const ok = "ocl-" + this.state.otherKeyTracer
		this.state.otherKeyTracer++
		const ocl = <OtherCropListItem crops={crops} view={this.props.view} handler={this.eventHandler} key={ok} id={ok} />
		oc.push(ocl)
		this.state.otherItemObj[ok] = ocl
		this.setState({
			crops: crops,
			permanentListItems: pc,
			otherListItems: oc
		})
		if(this.props.view === "view-details") {
			this.setAllFieldsDisabled(true)
		}
		else {
			this.setAllFieldsDisabled(false)
		}
	}

	setAllFieldsDisabled(v) {
		const fields = document.querySelectorAll('.crops-planted *')
		for(const f of fields) {
			f.disabled = v
		}
	}

	componentWillMount() {
		if(this.props.farmerID != null) {
			this.getFarmerInfo()
			return
		}
		const instrument = APIFarmerRequest.getAllCrops(this.state.accessToken)
		instrument.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.crop_id, name: v.name})
			}
			const permanentListItems = []
			const otherListItems = []
			const k = "pcl-" + this.state.keyTracer
			this.state.itemObj[k] = <PermanentCropListItem crops={c} view={this.props.view} handler={this.eventHandler} key={k} id={k} />
			this.state.keyTracer++
			permanentListItems.push(this.state.itemObj[k])
			const ok = "ocl-" + this.state.otherKeyTracer
			this.state.otherItemObj[ok] = <OtherCropListItem crops={c} view={this.props.view} handler={this.eventHandler} key={ok} id={ok} />
			this.state.otherKeyTracer++
			otherListItems.push(this.state.otherItemObj[ok])
			this.setState({crops: c, permanentListItems: permanentListItems, otherListItems: otherListItems})
		})
	}

	componentWillUnmount() {
		pclRanks = null
		selectedPclRanks = null
		oclRanks = null
		selectedOclRanks = null

	}
	eventHandler(e, compId, key, value) {
		switch(e) {
			case "existing-crops":
					this.state.cropsPlanted[compId] = value
					if(this.props.view === "update") {
						if(this.state.cropsPlanted[compId]["id"] != undefined && this.state.cropsPlanted[compId]["id"] != null) {
							this.props.onValueChange("crops-planted", "crops-planted", "existingCropAndMarket", this.state.cropsPlanted)
						} else {
							delete this.state.cropsPlanted[compId]
							this.props.onValueChange("crops-planted", "crops-planted", "existingCropAndMarket", this.state.cropsPlanted)
						}
					}
					console.log('existing-crops', this.state.cropsPlanted)
					this.props.onValueChange("crops-planted", "crops-planted", "existingCropAndMarket", this.state.cropsPlanted)
				break
			case "add":
				if(compId.includes("ocl")) {
					if(this.props.view === "update" && value != null) {
						this.state.addCrop[compId] = value
					}
					const added = []
					const k = "ocl-" + this.state.otherKeyTracer
					this.state.otherItemObj[k] = <OtherCropListItem crops={this.state.crops} view={this.props.view} handler={this.eventHandler} key={k} id={k} />
					this.state.otherKeyTracer++
					this.state.ocCount++
					Object.keys(this.state.otherItemObj).forEach((k => {
						added.push(this.state.otherItemObj[k])
					}))
					this.setState({otherListItems: added})
					if(oclRanks == null) {
						oclRanks = []
					}
					oclRanks.push({id: this.state.ocCount, name: this.state.ocCount})
				}
				else {
					if(this.props.view === "update"  && value != null) {
						this.state.addCrop[compId] = value
					}
					const added = []
					const k = "pcl-" + this.state.keyTracer
					this.state.itemObj[k] = <PermanentCropListItem crops={this.state.crops} view={this.props.view} handler={this.eventHandler} key={k} id={k} />
					this.state.keyTracer++
					this.state.pcCount++
					Object.keys(this.state.itemObj).forEach((k => {
						added.push(this.state.itemObj[k])
					}))
					this.setState({permanentListItems: added})
					if(pclRanks == null) {
						pclRanks = []
					}
					pclRanks.push({id: this.state.pcCount, name: this.state.pcCount})
				}
				this.props.onValueChange("crops-planted", "crops-planted", "add", this.state.addCrop)
				break
			case "delete":
				if(compId.includes("ocl")) {
					if(value != null && this.props.view === "update") {
						this.state.deleteCrop[compId] = value
						this.props.onValueChange("crops-planted", "crops-planted", "delete", this.state.deleteCrop)
						delete this.state.addCrop[compId]
						this.props.onValueChange("crops-planted","crops-planted", "add", this.state.addCrop)
					}
					if(this.state.otherListItems.length === 1) {
						break
					}
					delete this.state.otherItemObj[compId]
					const deleted = []
					Object.keys(this.state.otherItemObj).forEach((k => {
						deleted.push(this.state.otherItemObj[k])
					}))
					this.setState({otherListItems: deleted})
					this.state.ocCount--
					delete this.state.cropsPlanted[compId]
					this.props.onValueChange("crops-planted", "crops-planted", "existingCropAndMarket", this.state.cropsPlanted)
				}
				else {
					if(value != null && this.props.view === "update") {
						this.state.deleteCrop[compId] = value
						this.props.onValueChange("crops-planted", "crops-planted", "delete", this.state.deleteCrop)
						delete this.state.addCrop[compId]
						this.props.onValueChange("crops-planted","crops-planted", "add", this.state.addCrop)
					}
					if(this.state.permanentListItems.length === 1) {
						break
					}
					delete this.state.itemObj[compId]
					const deleted = []
					Object.keys(this.state.itemObj).forEach((k => {
						deleted.push(this.state.itemObj[k])
					}))
					this.setState({permanentListItems: deleted})
					this.state.pcCount--
					delete this.state.cropsPlanted[compId]
					this.props.onValueChange("crops-planted", "crops-planted", "existingCropAndMarket", this.state.cropsPlanted)
				}
		}
	}

	render() {
		const view = <div className="crops-planted">
			<div id="crops-count">
				<div id="cc1">Number of crops or grown/trees planted that contributes to the household income.</div>
				<div id="cc2">
					<div className="cc2-count">{this.state.pcCount}</div><div>Permanent Crops/Trees</div>
					<div className="cc2-count">{this.state.ocCount}</div><div>Other Crops</div>
				</div>
			</div>
			<div id="permanent-crops">
				<div id="pc1">PERMANENT CROPS/TREES</div>
				<div id="pc2">
					<table className="pc-table-header">
						<col style={{width: '15%'}} />
						<col style={{width: '15%'}} />
						<col style={{width: '15%'}} />
						<col style={{width: 'auto'}} />
						<col style={{width: '12%'}} />
						<tr>
							<th>Crop</th>
							<th>Area Planted (in hectares)</th>
							<th># of Productive Trees/Hills</th>
							<th>Name of Buyer/Market</th>
							<th>Rank</th>
						</tr>
					</table>
					{this.state.permanentListItems}
				</div>
			</div>
			<div id="other-crops">
				<div id="oc1">OTHER CROPS</div>
				<div id="oc2">
					<table className="oc-table-header">
						<col style={{width: '15%'}} />
						<col style={{width: '15%'}} />
						<col style={{width: 'auto'}} />
						<col style={{width: '12%'}} />
						<tr>
							<th>Crop</th>
							<th>Area Planted (in hectares)</th>
							<th>Name of Buyer/Market</th>
							<th>Rank</th>
						</tr>
					</table>
					{this.state.otherListItems}
				</div>

			</div>
		</div>
		return(view)
	}
}

let pclRanks
let selectedPclRanks
console.log('CropsPlanted.js')

class PermanentCropListItem extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			itemId: props.id,
			handler: props.handler,
			crops: props.crops,
			ranks: pclRanks,
			rank: "-- SELECT --",
			cropsplanted: {},
		}
		this.onAddItemClick = this.onAddItemClick.bind(this)
		this.onDeleteItem = this.onDeleteItem.bind(this)
		console.log('PermanentCropListItem constructur', pclRanks)
	}

	componentDidMount() {
		if(this.props.data != null) {
			selectedPclRanks[this.props.id] = this.props.data.crop_rank_id
			const crop = APIFarmerRequest.getCropById(this.state.accessToken, this.props.data.crop_id)
			this.state.cropsplanted["id"] = this.props.data.id
			this.state.cropsplanted["area_planted"] = this.props.data.area_planted
			crop.then((response) => {
				this.setState({crop: response.results.name})
			})
			this.setState({
				addDeleteButton: (this.props.view === "update")? <img src={deleteIcon} className="delete-icon" alt="DELETE" onClick={this.onDeleteItem} /> : <img src={deleteIconGray} className="delete-icon" alt="DELETE"/>,
				trees: this.props.data.no_of_productive_tree,
				buyer: this.props.data.buyer,
				areaPlanted: this.props.data.area_planted,
				rank: this.props.data.crop_rank_id
			})
		}
		else {
		this.setState({addDeleteButton: (this.props.view === "view-details")? <img src={addIconGray} className="add-icon" alt="ADD" />:<img src={addIcon} className="add-icon" alt="ADD" onClick={this.onAddItemClick} />})
		}
	}

	componentWillUnmount() {
		// pclRanks = null
		// selectedPclRanks = {}
	}

	onAddItemClick() {
		this.state.handler("add", this.state.itemId, null, this.state.cropsplanted)
		this.setState({addDeleteButton: <img src={deleteIcon} className="delete-icon" alt="DELETE" onClick={this.onDeleteItem} />})
	}

	onDeleteItem() {
		this.setState({
			showConfirmMessage: true,
			aMessage: `Are you sure you want to remove crop ${this.state.crop}?`
		})
	}

	render() {
		const view = <div className="pc-list-item">
			<div>{this.state.addDeleteButton}</div>
			<table className="pc-table-data">
				<col style={{width: '15%'}} />
				<col style={{width: '15%'}} />
				<col style={{width: '15%'}} />
				<col style={{width: 'auto'}} />
				<col style={{width: '12%'}} />
				<tr>
					<td><div>
						<InputTextFilterWidget list={this.state.crops} placeholder={this.state.crop} onItemSelected={(id, val) => {
							this.state.cropsplanted["crop_id"] = id
							this.props.handler("existing-crops", this.state.itemId, null, this.state.cropsplanted)
							if(this.state.addDeleteButton.props.alt == "ADD") {
								this.onAddItemClick()
							}
							this.setState({crop: val})
						}} cStyle={{"width": "100%"}} disabled={this.state.disabled} />
						{/* <DropdownWidget list={this.state.crops} placeholder={this.state.targetCrop}
						cStyle={{"width": "calc(100% - 5px)"}} onItemSelected={(id, val) => {
							this.state.cropsplanted["crop_id"] = id
							this.props.handler("existing-crops", this.state.itemId, null, this.state.cropsplanted)
							if(this.state.addDeleteButton.props.alt == "ADD") {
								this.onAddItemClick()
							}
							this.setState({crop: val})
						}} /> */}
					</div></td>
					<td><input type="text" value={this.state.areaPlanted} placeholder='0' onChange={(e) => {
						const checker = /^[\d,]+\.?\d{0,4}?$/
						const isValid = checker.test(e.target.value)
						console.log(isValid, e.target.value)
						if(isValid) {
							this.state.cropsplanted["area_planted"] = e.target.value
							this.props.handler("existing-crops", this.state.itemId, null, this.state.cropsplanted)
							if(this.state.addDeleteButton.props.alt == "ADD") {
								this.onAddItemClick()
							}
							this.setState({areaPlanted: e.target.value})
						}
						else {
							if(isNaN(parseInt(e.target.value))) {
								e.target.value = ""
								this.setState({areaPlanted: ""})
							}
							else {
								e.target.value = parseInt(e.target.value)
							}
						}
					}} /></td>
					<td><input type="text" value={this.state.trees} placeholder='0' onChange={(e) => {
						const checker = /^[0-9.]+$/
						const isValid = checker.test(e.target.value)
						if(isValid) {
							this.state.cropsplanted["no_of_productive_tree"] = e.target.value
							this.props.handler("existing-crops", this.state.itemId, null, this.state.cropsplanted)
							if(this.state.addDeleteButton.props.alt == "ADD") {
								this.onAddItemClick()
							}
							this.setState({trees: e.target.value})
						}
						else {
							if(isNaN(parseInt(e.target.value))) {
								e.target.value = ""
								this.setState({trees: ""})
							}
							else {
								e.target.value = parseInt(e.target.value)
							}
						}
					}} /></td>
					<td><input type="text" value={this.state.buyer} onChange={(e) => {
						this.state.cropsplanted["buyer"] = e.target.value
						this.props.handler("existing-crops", this.state.itemId, null, this.state.cropsplanted)
						if(this.state.addDeleteButton.props.alt == "ADD") {
							this.onAddItemClick()
						}
						this.setState({buyer: e.target.value})
					}} /></td>
					<td>
						<div onMouseDown={(e) => {
							let ranks = [{id: 0, name: "-- SELECT --"}]
							if (selectedPclRanks.length === 0 ) {
								for(const v of pclRanks) {
									ranks.push(v)
								}
							}
							else {
								for(const v of pclRanks) {
									let foundIndex = Object.values(selectedPclRanks).includes(v.id)
									if(!foundIndex) {
										ranks.push(v)
									}
								}
							}
							this.setState({ranks: ranks})
						}}><DropdownWidget list={this.state.ranks} placeholder={this.state.rank} cStyle={{"width": "calc(100% - 5px)"}} onItemSelected={(id, val) => {
							this.state.cropsplanted["crop_rank_id"] = id
							selectedPclRanks[this.state.itemId] = parseInt(id)
							this.props.handler("existing-crops", this.state.itemId, null, this.state.cropsplanted)
							if(this.state.addDeleteButton.props.alt == "ADD") {
								this.onAddItemClick()
							}
						}} /></div>
					</td>
				</tr>
			</table>
			{this.state.showConfirmMessage == true && <AlertMessage type="confirmation" text={this.state.aMessage}
			onClick={(e) => {
				this.setState({showConfirmMessage: false})
				if(e.target.innerHTML === "NO") {
				}
				else {
					pclRanks.pop()
					delete selectedPclRanks[this.props.id]
					this.state.handler("delete", this.state.itemId, null, this.state.cropsplanted)
				}
			}} />}
		</div>
		return(view)
	}
}

let oclRanks
let selectedOclRanks

class OtherCropListItem extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			itemId: props.id,
			handler: props.handler,
			crops: props.crops,
			ranks: oclRanks,
			rank: "-- SELECT --",
			cropsplanted: {},
		}
		this.onAddItemClick = this.onAddItemClick.bind(this)
		this.onDeleteItem = this.onDeleteItem.bind(this)
	}

	componentDidMount() {
		if(this.props.data != null) {
			selectedOclRanks[this.props.id] = this.props.data.crop_rank_id
			this.state.cropsplanted["id"] = this.props.data.id
			this.state.cropsplanted["area_planted"] = this.props.data.area_planted
			const crop = APIFarmerRequest.getCropById(this.state.accessToken, this.props.data.crop_id)
			crop.then((response) => {
				this.setState({crop: response.results.name})
			})
			this.setState({
				addDeleteButton: (this.props.view === "update")? <img src={deleteIcon} className="delete-icon" alt="DELETE" onClick={this.onDeleteItem} /> : <img src={deleteIconGray} className="delete-icon" alt="DELETE"/>,
				buyer: this.props.data.buyer,
				areaPlanted: this.props.data.area_planted,
				rank: this.props.data.crop_rank_id,
			})
		}
		else {
			this.setState({addDeleteButton: (this.props.view === "view-details")? <img src={addIconGray} className="add-icon" alt="ADD" />:<img src={addIcon} className="add-icon" alt="ADD" onClick={this.onAddItemClick} />})
		}
	}

	componentWillUnmount() {
		// oclRanks = null
		// selectedOclRanks = {}
	}

	onAddItemClick() {
		this.state.handler("add", this.state.itemId, null, this.state.cropsplanted)
		this.setState({addDeleteButton: <img src={deleteIcon} className="delete-icon" alt="DELETE" onClick={this.onDeleteItem} />})
	}

	onDeleteItem() {
		// oclRanks.pop()
		// delete selectedOclRanks[this.props.id]
		// this.state.handler("delete", this.state.itemId, null, this.state.cropsplanted)
		this.setState({
			showConfirmMessage: true,
			aMessage: `Are you sure you want to remove crop ${this.state.crop}?`
		})
	}

	render() {
		const view = <div className="oc-list-item">
			<div>{this.state.addDeleteButton}</div>
			<table className="oc-table-data">
						<col style={{width: '15%'}} />
						<col style={{width: '15%'}} />
						<col style={{width: 'auto'}} />
						<col style={{width: '12%'}} />
				<tr>
					<td>
						<InputTextFilterWidget list={this.state.crops} placeholder={this.state.crop} onItemSelected={(id, val) => {
							this.state.cropsplanted["crop_id"] = id
							this.props.handler("existing-crops", this.state.itemId, null, this.state.cropsplanted)
							if(this.state.addDeleteButton.props.alt == "ADD") {
								this.onAddItemClick()
							}
							this.setState({crop: val})
						}} cStyle={{"width": "100%"}} disabled={this.state.disabled} />
						{/* <DropdownWidget list={this.state.crops} placeholder={this.state.crop}
						cStyle={{"width": "calc(100% - 5px)"}} onItemSelected={(id, val) => {
							this.state.cropsplanted["crop_id"] = id
							this.props.handler("existing-crops", this.state.itemId, null, this.state.cropsplanted)
							if(this.state.addDeleteButton.props.alt == "ADD") {
								this.onAddItemClick()
							}
							this.setState({crop: val})
						}} /> */}
					</td>
					<td><input type="text" value={this.state.areaPlanted} placeholder='0' onChange={(e) => {
						const checker = /^[\d,]+\.?\d{0,4}?$/
						const isValid = checker.test(e.target.value)
						if(isValid) {
							this.state.cropsplanted["area_planted"] = e.target.value
							this.props.handler("existing-crops", this.state.itemId, null, this.state.cropsplanted)
							if(this.state.addDeleteButton.props.alt == "ADD") {
								this.onAddItemClick()
							}
							this.setState({areaPlanted: e.target.value})
						}
						else {
							if(isNaN(parseInt(e.target.value))) {
								e.target.value = ""
								this.setState({areaPlanted: ''})
							}
							else {
								e.target.value = parseInt(e.target.value)
							}
						}
					}} /></td>
					<td><input type="text" value={this.state.buyer} onChange={(e) => {
						this.state.cropsplanted["buyer"] = e.target.value
						this.props.handler("existing-crops", this.state.itemId, null, this.state.cropsplanted)
						if(this.state.addDeleteButton.props.alt == "ADD") {
							this.onAddItemClick()
						}
						this.setState({buyer: e.target.value})
					}} /></td>
					<td><div onMouseDown={(e) => {
						let ranks = [{id: 0, name: "-- SELECT --"}]
						if (selectedOclRanks.length === 0 ) {
							for(const v of oclRanks) {
								ranks.push(v)
							}
						} else {
							for(const v of oclRanks) {
								let foundIndex = Object.values(selectedOclRanks).includes(v.id)
								if(!foundIndex) {
									ranks.push(v)
								}
							}
						}
						this.setState({ranks: ranks})
						}}>
						<DropdownWidget list={this.state.ranks} placeholder={this.state.rank} cStyle={{"width": "calc(100% - 5px)"}}
						onItemSelected={(id, val) => {
							this.state.cropsplanted["crop_rank_id"] = id
							selectedOclRanks[this.state.itemId] = parseInt(id)
							this.props.handler("existing-crops", this.state.itemId, null, this.state.cropsplanted)
							if(this.state.addDeleteButton.props.alt == "ADD") {
								this.onAddItemClick()
							}
						}} />
					</div></td>
				</tr>
			</table>
			{this.state.showConfirmMessage == true && <AlertMessage type="confirmation" text={this.state.aMessage}
			onClick={(e) => {
				this.setState({showConfirmMessage: false})
				if(e.target.innerHTML === "NO") {
				}
				else {
					oclRanks.pop()
					delete selectedOclRanks[this.props.id]
					this.state.handler("delete", this.state.itemId, null, this.state.cropsplanted)
				}
			}} />}
		</div>
		return(view)
	}
}

export default CropsPlanted
